export interface ContactCard {
  name: string;
  description: string;
  email: string;
  role: string;
  palette: string;
}

export interface RawContactCard {
  name: string;
  description: string;
  email: string;
}

export enum AccountManagerRawDataStatus {
  ASSIGNED = 'ASSIGNED',
  HUBSPOT_API_FAILED = 'HUBSPOT_API_FAILED',
  AM_NOT_ASSIGNED = 'AM_NOT_ASSIGNED',
  TAM_NOT_ASSIGNED = 'TAM_NOT_ASSIGNED',
  NOT_ASSIGNED = 'NOT_ASSIGNED',
  INVALID_TEAM = 'INVALID_TEAM',
}

export interface AccountManagersRawData {
  account_manager?: RawContactCard;
  technical_account_manager?: RawContactCard;
  status: AccountManagerRawDataStatus;
}
